import React from 'react';

import './loading.css';

const Loading = ({status})=>{
  let active=false;

  if(Array.isArray(status)) {
    active=status.some(elem=>elem==='loading');
  } else {
    active=status==='loading'
  }
  if(!active) {
    return false;
  }

  return (
    <div className="loading">
      <p><i className="icon-spin3 animate-spin"></i></p>
    </div>
  )
}

export default Loading;